import Vue from 'vue'
import Router from 'vue-router'
import MainContainer from '@/containers/MainContainer';
import WarehousesList from "../components/warehouses/WarehousesList";
import WarehouseDetails from "../components/warehouses/WarehouseDetails";
import AddWarehouse from "../components/warehouses/AddWarehouse";
import OrderDetails from "../components/orders/OrderDetails";
import IncomingStock from "../components/incomingStock/IncomingStock";

// Views
const Login = () => import('@/components/Login')

// Views - Orders
const OrdersList = () => import('@/components/orders/OrdersList')

// Views - Items
const ItemsList = () => import('@/components/items/ItemsList')
const ItemDetails = () => import('@/components/items/ItemDetails')


Vue.use(Router)


const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    redirect: '/orders',
    name: 'Home',
    component: MainContainer,
    children: [
      {
        path: 'orders',
        name: 'orders-list',
        component: OrdersList,
      },
      {
        path: 'orders/:id',
        name: 'order-details',
        component: OrderDetails,
      },
      {
        'path': 'items',
        'name': 'items-list',
        component: ItemsList,
      },
      {
        path: 'items/:id',
        name: 'item-details',
        component: ItemDetails
      },
      {
        'path': 'warehouses',
        'name': 'warehouses-list',
        component: WarehousesList,
      },
      {
        'path': 'warehouses/add',
        'name': 'add-warehouse',
        component: AddWarehouse,
      },
      {
        path: 'warehouses/:id',
        name: 'warehouse-details',
        component: WarehouseDetails
      },
      {
        path: 'incoming_stock',
        name: 'incoming-stock',
        component: IncomingStock
      }
    ]
  }
]

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  routes: routes
})

